import { request } from '@wix/da-shared-react/pkg/xhr';
import { call, put } from 'redux-saga/effects';
import { leaveGroupSuccess } from '../actions/groups';
import { API_BASE_PATH } from '../../constants';

function* leaveGroupRequest(data) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/groups/leave`,
    data,
  });
}

export default function* leaveGroupSaga(action) {
  const {
    payload: { group },
  } = action;
  const response = yield call(leaveGroupRequest, { groupid: group.userId });

  if (response && response.success) {
    yield put(leaveGroupSuccess(group));
    // TODO: update all the streams and normalized entities
  }
}
